import { GO_TO_PROJECT_STEP } from '#action/types';

export const goToProjectStep = step => dispatch => {
  dispatch({ type: GO_TO_PROJECT_STEP, payload: step });
};
